module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 1-7de1c3dfc7819f6efa4b2a7df50055d0.jpg";